import { UIChunkType } from '@myre/app-agent-domain';

import { Component, inject, input, signal } from '@angular/core';
import { isDataUIPart } from 'ai';

import {
  type CtaItem,
  type MyreUiMessagePart,
} from '../../interfaces/chat.interfaces';
import { CtaService, type CtaResult } from '../../services/cta.service';

@Component({
  selector: 'app-cta-buttons',
  standalone: true,
  templateUrl: './cta-buttons.component.html',
  styleUrl: './cta-buttons.component.scss',
})
export class CtaButtonsComponent {
  private readonly _ctaService = inject(CtaService);

  public readonly part = input.required<MyreUiMessagePart>();
  public readonly streaming = input<boolean>(false);

  protected readonly _results = this._ctaService.results;
  protected readonly _pending = signal<Set<string>>(new Set());

  protected get _ctas(): CtaItem[] {
    const part = this.part();

    if (!isDataUIPart(part) || part.type !== UIChunkType.DataCta) {
      return [];
    }

    return (part.data as { ctas?: CtaItem[] }).ctas ?? [];
  }

  protected _getResult(label: string): CtaResult | undefined {
    return this._results().get(label);
  }

  protected _isPending(label: string): boolean {
    return this._pending().has(label);
  }

  protected _onClick(cta: CtaItem): void {
    this._pending.update(set => {
      const updated = new Set(set);

      updated.add(cta.label);

      return updated;
    });

    void this._ctaService.execute(cta).finally(() => {
      this._pending.update(set => {
        const updated = new Set(set);

        updated.delete(cta.label);

        return updated;
      });
    });
  }
}
